import { Component, OnInit, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminRoleService } from '../service/admin-role.service';
import { UtilService } from '../service/util.service';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { Constants } from '../constants/constants';
import { ToastService } from '../service/toast.service';
import { NgForm } from '@angular/forms';
import { RolePipe } from '../pipe/role.pipe';

@Component({
  selector: 'app-view-user-detail',
  templateUrl: './view-user-detail.component.html',
  styleUrls: ['./view-user-detail.component.scss']
})
export class ViewUserDetailComponent implements OnInit {


  @Output() onCloseViewEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onActivateUserEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDeactivateUserEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onResendInviteEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUpdateUserRoleEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onResetUserPasswordEmitter: EventEmitter<any> = new EventEmitter<any>();

  status: Array<string> = ["INACTIVE", "PENDING", "ACTIVE", "DISABLED"];
  adminId: string;
  admin: any = null;
  adminRoles: any;
  adminStatus: string = this.status[2];
  adminList: any = [];
  loggedInUserId: any;
  updateRoleModal = null;
  rolePipe: RolePipe = new RolePipe();
  authSubscription: any;
  isSelfAccount = false;
  currentConfirmation = {
    heading: null,
    content: null
  }

  @ViewChild('updateRoleForm', { static: true }) public updateRoleForm: NgForm;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) {
    this.authSubscription = this.authService.authenticationState.subscribe(state => {
      console.log("Auth Changed : ", state, " logged in user details : ", this.authService.loggedInUser);
    });
  }

  ngOnInit() {
    this.admin = this.utilService.selectedAccountUser;
    this.adminStatus = (this.admin && this.admin.status) ? this.admin.status : this.status[2];
    console.log("admin :: ", this.admin, " -- logged in user : ", this.authService.loggedInUser);
    this.loggedInUserId = this.authService.loggedInUser.userId;
    this.initUpdateRoleModal();
    this.setIsSelfAccount();
  }

  setIsSelfAccount() {
    if (this.admin.id == this.authService.loggedInUser.userId) {
      this.isSelfAccount = true;
    }
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  closeViewClicked() {
    this.onCloseViewEmitter.emit();
  }

  onUserDeactivate() {
    this.currentConfirmation.heading = "Deactivate User";
    this.currentConfirmation.content = "Confirm deactivating " + this.admin.name + " ?";
    document.getElementById("openConfirmationModel").click();
  }

  onUserActivate() {
    console.log("Activating user : ", this.admin.id);
    // this.activateUser(this.admin.id);
    this.onActivateUserEmitter.emit(this.admin.id);
  }

  onResetPassword() {
    this.currentConfirmation.heading = "Reset Password";
    this.currentConfirmation.content = "Confirm reset password for " + this.admin.name + " ?";
    document.getElementById("openConfirmationModel").click();
  }

  onInviteResend() {
    this.currentConfirmation.heading = "Resend Invite";
    this.currentConfirmation.content = "Confirm resend invite to for " + this.admin.name + " ?";
    document.getElementById("openConfirmationModel").click();
  }

  onResetUserPassword() {
    document.getElementById("closeConfirmationModel").click();
  }

  confirm() {

    if (this.currentConfirmation.heading == "Deactivate User") {
      // Handle user deactivate
      console.log("Deactivating user : ", this.admin.id);
      this.onDeactivateUserEmitter.emit(this.admin.id);
      // this.deactivateUser(this.admin.id);
    } else if (this.currentConfirmation.heading == "Reset Password") {
      // Handle user password reset
      console.log("Reset user : ", this.admin.username);
      this.onResetUserPasswordEmitter.emit({"username": this.admin.username});
      // this.resetUserPassword(this.admin.username);
    } else if (this.currentConfirmation.heading == "Update Role") {
      document.getElementById("closeConfirmationModel").click();
      this.onUpdateUserRoleEmitter.emit({'payload': this.getUpdateRolePayload(), 'adminId': this.admin.id});
      // this.roleUpdateConfirmed();
    } else if (this.currentConfirmation.heading == "Resend Invite") {
      document.getElementById("closeConfirmationModel").click();
      this.onResendInviteEmitter.emit(this.admin.id);
      // this.resendInvite(this.admin.id);
    }

  }

  onUserDeactivated() {
    this.toast.showSuccess("User deactivated successfully");
    this.adminStatus = this.status[3];
    document.getElementById("closeConfirmationModel").click();
  }

  onUserActivated() {
    this.adminStatus = this.status[2];
    this.toast.showSuccess("User activated successfully");
    document.getElementById("closeConfirmationModel").click();
  }

  onResendInviteSent() {
    document.getElementById("closeConfirmationModel").click();
  }

  onUserRoleUpdated(payload) {
    this.toast.showSuccess("User role updated successfully");
    document.getElementById("closeUpdateRole").click();
    this.admin.roles = JSON.parse(JSON.stringify(payload));
    this.resetUpdateRoleForm();
  }

  resetUserPassword(username) {
    var resetPasswordRequest = {
      "username": username
    };

    this.utilService.showSpinner();
    this.authService.forgotPassword(resetPasswordRequest).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess(data['message']);
      document.getElementById("closeConfirmationModel").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.resetUserPassword(username);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  initUpdateRoleModal() {
    this.updateRoleModal = {
      roles: new Array(),
      fleetDemoAppRole: null
    }

    if (this.admin && this.admin.roles) {
      for (var i = 0; i < this.admin.roles.length; i++) {
        var role = this.admin.roles[i];
        if (this.rolePipe.isFleetDemoAppRole(role)) {
          this.updateRoleModal.fleetDemoAppRole = role;
        } else {
          this.updateRoleModal.roles.push(role);
        }
      }
    }

    console.log("init update role modal value : ", this.updateRoleModal);
  }

  openUpdateRole() {
    document.getElementById("openUpdateRole").click();
  }

  updateRoleFormSubmit(form: NgForm) {
    this.updateRoleForm = form;
    console.log("Form submit");

    var payload = this.getUpdateRolePayload();

    if (payload.length > 0) {
      this.currentConfirmation.heading = "Update Role";
      this.currentConfirmation.content = " Confirm updating roles for " + this.admin.name + " ?";
      document.getElementById("openConfirmationModel").click();
    } else {
      this.toast.showWarning("Select atleast 1 role");
    }
  }

  getUpdateRolePayload() {
    var payload = new Array();
    for (var i = 0; i < this.updateRoleModal.roles.length; i++) {
      payload.push(this.updateRoleModal.roles[i]);
    }

    if (this.updateRoleModal.fleetDemoAppRole)
      payload.push(this.updateRoleModal.fleetDemoAppRole);

    return payload;
  }

  roleUpdateConfirmed() {
    console.log("Role update confirmed api calling : ", this.updateRoleModal);

    var payload = this.getUpdateRolePayload();

    console.log("final payload : ", payload);
    this.utilService.showSpinner();
    this.apiService.updateUserRole(payload, this.admin.id).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess("User role updated successfully");
      document.getElementById("closeUpdateRole").click();
      this.admin.roles = JSON.parse(JSON.stringify(payload));
      this.resetUpdateRoleForm();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.roleUpdateConfirmed();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resetUpdateRoleForm() {
    if (this.updateRoleForm) {
      this.updateRoleForm.reset();
      this.updateRoleForm.resetForm();
    }
    this.initUpdateRoleModal();
  }

  fleetDemoAppRoleClicked(key) {
    this.updateRoleModal.fleetDemoAppRole = key;
  }

  roleSelected(roleKey) {
    var isPresent = false;
    var presentIndex = 0;
    for (var i = 0; i < this.updateRoleModal.roles.length; i++) {
      if (roleKey == this.updateRoleModal.roles[i]) {
        isPresent = true;
        presentIndex = i;
        break;
      }
    }
    if (isPresent) {
      this.updateRoleModal.roles.splice(presentIndex, 1);
    } else {
      this.updateRoleModal.roles.push(roleKey);
    }

    console.log("final selected list : ", this.updateRoleModal.roles);
  }

  isRolePresent(role) {
    var flag = false;
    for (var i = 0; i < this.updateRoleModal.roles.length; i++) {
      if (role == this.updateRoleModal.roles[i]) {
        flag = true;
        break;
      }
    }
    return flag;
  }
}
